module.exports = __webpack_public_path__ + "static/img/AccountSupport_img3.fe05ffb0.png";